import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// For protected routes (redirects to login if not authenticated)
export const ProtectedRoute: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login but save the location they were trying to access
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};

// For auth routes (login/verify) - redirects to home if already authenticated
export const AuthRoute: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem('authToken');

  if (isAuthenticated) {
    // If user is already logged in, redirect to home
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

// For admin protected routes - redirects to admin login if not authenticated or not admin
export const AdminProtectedRoute: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  const userRole = localStorage.getItem('userRole');
  const userData = localStorage.getItem('userData');
  const location = useLocation();

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  // Check if user is admin (check both userRole and userData)
  let isAdmin = userRole === 'admin';
  if (!isAdmin && userData) {
    try {
      const parsedUserData = JSON.parse(userData);
      isAdmin = parsedUserData.userType === 'Admin';
    } catch (error) {

    }
  }

  if (!isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};
